import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import LeadVideoSection from "@/components/LeadVideoSection";
import Process from "@/components/Process";
import LazySection from "@/components/LazySection";
import SectionSkeleton from "@/components/SectionSkeleton";

const Testimonials = lazy(() => import("@/components/Testimonials"));
const Videos = lazy(() => import("@/components/Videos"));
const FAQ = lazy(() => import("@/components/FAQ"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Benefits />
      <LeadVideoSection />
      <Process />
      <LazySection fallback={<SectionSkeleton tone="dark" />}>
        <Suspense fallback={<SectionSkeleton tone="dark" />}>
          <Testimonials />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="light" />}>
        <Suspense fallback={<SectionSkeleton tone="light" />}>
          <Videos />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="light" />}>
        <Suspense fallback={<SectionSkeleton tone="light" />}>
          <FAQ />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="dark" />}>
        <Suspense fallback={<SectionSkeleton tone="dark" />}>
          <FinalCTA />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="dark" />}>
        <Suspense fallback={<SectionSkeleton tone="dark" />}>
          <Footer />
        </Suspense>
      </LazySection>
    </div>
  );
};

export default Index;
